package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class PrescriptionSubCategory(private val literal: String) : IEnumType {
	辛温解表("辛温解表"),
	辛凉解表("辛凉解表"),
	扶正解表("扶正解表"),
	表里双解("表里双解"),
	寒下("寒下"),
	温下("温下"),
	润下("润下"),
	逐水("逐水"),
	攻补兼施("攻补兼施"),
	和解少阳("和解少阳"),
	调和肝脾("调和肝脾"),
	调和肠胃("调和肠胃"),
	清气分热("清气分热"),
	清营凉血("清营凉血"),
	清热解毒("清热解毒"),
	清脏腑热("清脏腑热"),
	清虚热("清虚热"),
	祛暑方("祛暑方"),
	温中祛寒("温中祛寒"),
	回阳救逆("回阳救逆"),
	温经散寒("温经散寒"),
	补气("补气"),
	补血("补血"),
	气血双补("气血双补"),
	补阴("补阴"),
	补阳("补阳"),
	阴阳双补("阴阳双补"),
	固表止汗("固表止汗"),
	敛肺止咳("敛肺止咳"),
	涩肠固脱("涩肠固脱"),
	涩精止遗("涩精止遗"),
	固崩止带("固崩止带"),
	重镇安神("重镇安神"),
	滋养安神("滋养安神"),
	凉开("凉开"),
	温开("温开"),
	行气("行气"),
	降气("降气"),
	活血祛瘀("活血祛瘀"),
	止血("止血"),
	疏散外风("疏散外风"),
	平熄内风("平熄内风"),
	轻宣外燥("轻宣外燥"),
	滋阴润燥("滋阴润燥"),
	燥湿和胃("燥湿和胃"),
	清热祛湿("清热祛湿"),
	利水渗湿("利水渗湿"),
	温化寒湿("温化寒湿"),
	祛风胜湿("祛风胜湿"),
	燥湿化痰("燥湿化痰"),
	清热化痰("清热化痰"),
	润燥化痰("润燥化痰"),
	温化寒痰("温化寒痰"),
	化痰熄风("化痰熄风"),
	消食化滞("消食化滞"),
	健脾消食("健脾消食"),
	驱虫方("驱虫方"),
	涌吐方("涌吐方"),
	内服("内服"),
	外用("外用");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "prescription_sub_category"}
	override fun getLiteral(): String {return literal}
}
